module.exports = __webpack_public_path__ + "static/img/domain_bg.edef4877.png";